import { render } from "./PassengerInfo.vue?vue&type=template&id=6d1db560&scoped=true"
import script from "./PassengerInfo.vue?vue&type=script&lang=js"
export * from "./PassengerInfo.vue?vue&type=script&lang=js"

import "./PassengerInfo.vue?vue&type=style&index=0&id=6d1db560&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1db560"]])

export default __exports__